import { CardHeader } from "../card-header";
import { styled } from "../styles";
var ExpansionPanelHeader = styled(CardHeader)({
    margin: 0,
});
ExpansionPanelHeader.displayName = "ExpansionPanelHeader";
export { ExpansionPanelHeader };
